/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { OutputSelector, createSelector } from 'reselect';

import { IRootReducer } from '@reducers/rootReducer';

import { ENotificationsItemType } from './constants';
import { INotificationsItem, INotificationsSlice, TNotificationsSettings } from './types';

export const getUserNotificationsState = (state: IRootReducer): INotificationsSlice => state.userNotifications ?? {};

export const makeSelectUserNotificationsItems = (): OutputSelector<
    IRootReducer,
    INotificationsItem[],
    (state: INotificationsSlice) => INotificationsItem[]
> => createSelector(getUserNotificationsState, (state: INotificationsSlice) => state.notificationsList.elements);

export const makeSelectUserNotificationsSettings = (): OutputSelector<
    IRootReducer,
    TNotificationsSettings | null,
    (state: INotificationsSlice) => TNotificationsSettings | null
> => createSelector(getUserNotificationsState, (state: INotificationsSlice) => state.notificationsSettings);

export const makeSelectUserNotificationsNewsEnabled = (): OutputSelector<
    IRootReducer,
    boolean,
    (state: INotificationsSlice) => boolean
> =>
    createSelector(
        getUserNotificationsState,
        (state: INotificationsSlice) =>
            !!state.notificationsSettings?.showNews && state.notificationsList.newsAvailable,
    );

export const makeSelectUserPushNotifications = (): OutputSelector<
    IRootReducer,
    INotificationsItem[],
    (state: INotificationsSlice) => INotificationsItem[]
> =>
    createSelector(getUserNotificationsState, (state: INotificationsSlice) =>
        state.notificationsList.elements.filter(
            (el) => el.type !== ENotificationsItemType.NOTIFICATION_BANNER && !el.shownByPush,
        ),
    );
